import {NextIcon} from 'components/NextImage';

import styles from './GearCard.module.scss';

export type ProductActionsProps = {
  actions: {
    icon: string;
    label: string | number;
    callback: () => any;
  }[];
}

export const GearActions = ({actions = []}: ProductActionsProps) => {
  return (
    <div className={styles.productActions}>
      {actions.map((action, index) => (
        <div key={index} className={styles.productAction} onClick={action.callback}>
          <NextIcon src={action.icon} />
          {action.label && <p>{action.label}</p>}
        </div>
      ))}
    </div>
  );
};
